import firebase from 'firebase/compat/app'
import dayjs from 'dayjs'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/functions'
const db = firebase.firestore()

const state = {
  isLoggedIn: false,
  user: null,
  loading: false,
  error: null,
  statusOptions: [
    { text: 'Active', value: true },
    { text: 'Inactive', value: false }
  ],
  paymentOptions: [
    { text: 'Free', value: false },
    { text: 'Paid', value: true }
  ],
  applicationTypes: [
    { text: 'Exceptional Talent', value: 'talent' },
    { text: 'Exceptional Promise', value: 'promise' }
  ],
  requirementTypes: [
    { text: 'Mandatory criteria', value: 'mandatoryCriteria' },
    { text: 'Optional criteria', value: 'optionalCriteria' },
    { text: 'Letter of recommendation', value: 'letterOfRecommendation' },
    { text: 'CV', value: 'cv' },
    { text: 'Personal statement', value: 'personalStatement' },
    { text: 'Other', value: 'other' }
  ],
  activeSubscription: null
}

const actions = {
  GOOGLE_SIGN_IN ({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    return firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .then(res => {
        commit('SET_LOADING', false)
        commit('SET_LOADED_USER', res.user)
        return db.collection('users').doc(res.user.uid).get().then(doc => {
          if (!doc.exists) {
            db.collection('users').doc(res.user.uid).set({
              id: res.user.uid,
              email: res.user.email,
              name: res.user.displayName,
              photoUrl: res.user.photoURL,
              createdAt: dayjs().format(),
              updatedAt: dayjs().format(),
              isAdmin: false,
              isActive: true,
              isApplicant: true
            })
          } else {
            db.collection('users').doc(res.user.uid).update({
              lastLogin: dayjs().format()
            })
            commit('SET_LOADED_USER', doc.data())
          }
          return doc
        })
      })
      .catch(err => {
        commit('SET_LOADING', false)
        commit('SET_ERROR', err)
      })
  },
  LOGIN_USER ({ commit }, { email, password }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    firebase.auth().signInWithEmailAndPassword(email, password).then((userRes) => {
      // var user = firebase.auth().currentUser
      commit('SET_LOADING', false)
      // commit('SET_LOADED_USER', user)

      db.collection('users').doc(userRes.user.uid).get().then((doc) => {
        if (doc.exists) {
          db.collection('users').doc(userRes.user.uid).update({
            lastLogin: dayjs().format()
          })
          commit('SET_LOADED_USER', doc.data())
        }
      })
    }).catch(error => {
      commit('SET_LOADING', false)
      commit('SET_ERROR', error)
    })
  },
  REGISTER ({ commit }, form) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    firebase.auth().createUserWithEmailAndPassword(form.email, form.password).then((response) => {
      // create user obj
      const collectionType = 'users'
      const collectionId = response.user.uid
      db.collection(collectionType).doc(collectionId).set({
        id: response.user.uid,
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        createdAt: dayjs().format(),
        updatedAt: dayjs().format(),
        isAdmin: false,
        isActive: true,
        isApplicant: true
      }).then(() => {
        commit('SET_LOADING', false)
        // commit('SET_LOADED_USER', response.user)
        db.collection(collectionType).doc(collectionId).get().then((doc) => {
          if (doc) {
            commit('SET_LOADED_USER', doc.data())
          }
        })
      }).catch(error => {
        commit('SET_LOADING', false)
        commit('SET_ERROR', error)
      })
    }).catch(error => {
      commit('SET_LOADING', false)
      commit('SET_ERROR', error)
    })
  },
  RESET_PASSWORD ({ commit }, { email }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    firebase.auth().sendPasswordResetEmail(email).then(() => {
      commit('SET_LOADING', false)
    }).catch(error => {
      commit('SET_LOADING', false)
      commit('SET_ERROR', error)
    })
  },
  AUTO_SIGN_IN ({ commit }, payload) {
    db.collection('users').doc(payload.uid).get().then((doc) => {
      if (doc.exists) {
        commit('SET_LOADED_USER', doc.data())
      }
    }).catch((error) => {
      console.error('Failed to auto sign-in:', error)
    })
  },
  LOGOUT ({ commit }) {
    commit('LOGOUT')
    firebase.auth().signOut()
    localStorage.removeItem('token')
    window.location.href = window.location.origin
  },
  SET_LOADING ({ commit }, payload) {
    commit('SET_LOADING', payload)
  },
  SET_ERROR ({ commit }, payload) {
    commit('SET_ERROR', payload)
  },
  CLEAR_ERROR ({ commit }) {
    commit('CLEAR_ERROR')
  },
  GET_USER ({ commit, state }) {
    if (!state.user) {
      return Promise.resolve()
    }
    const id = state.user.id
    return db.collection('users').doc(id).get().then((doc) => {
      if (doc.exists) {
        commit('SET_LOADED_USER', doc.data())
      }
      return doc
    })
  },
  UPDATE_PROFILE ({ commit, state }, payload) {
    const collectionType = 'users'
    const collectionId = state.user.id
    return db.collection(collectionType).doc(collectionId).update(payload.form).then(snapshot => {
      return db.collection(collectionType).doc(collectionId).get().then((doc) => {
        if (doc) {
          commit('SET_LOADED_USER', doc.data())
        }
        return snapshot
      })
    })
  },
  async REDIRECT_TO_CUSTOMER_PORTAL ({ commit, state }) {
    const functionRef = firebase
      .app()
      .functions('europe-west3')
      .httpsCallable('ext-firestore-stripe-payments-createPortalLink')
    const { data } = await functionRef({
      returnUrl: window.location.origin,
      locale: 'auto'
    })
    window.location.assign(data.url)
  }
}

const getters = {
  loadedUser: (state) => (id) => {
    return state.user && state.user.id === id ? state.user : null
  },
  getUser (state) {
    return state.user
  },
  isLoading (state) {
    return state.loading
  },
  getError (state) {
    return state.error
  }
}

const mutations = {
  SET_LOADED_USER (state, payload) {
    state.user = payload
  },
  SET_LOADING (state, payload) {
    state.loading = payload
  },
  SET_ERROR (state, payload) {
    state.error = payload
  },
  CLEAR_ERROR (state) {
    state.error = null
  },
  LOGOUT (state) {
    state.user = null
    state.token = null
    state.isLoggedIn = false
  },
  SET_LOADED_SUBSCRIPTION (state, payload) {
    state.activeSubscription = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
